// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"e8f862b5b16606fe7216","115":"61dc231e53649730f92e","116":"3a9632b0046b46909bb3","179":"3b05d09a4076fe58d091"}[chunkId] + ".chunk.js";
};